import * as Common from '@/tenant/common';
import { StockBalanceJournal } from '../Journal/StockBalanceJournal';
import { InvoiceTypes } from './Invoice';

export class DeliveryItem extends StockBalanceJournal{
  constructor(){
    super('DeliveryItem');
    this.binders.delivery = new Common.ModelBinder(Common.Delivery);
    this.binders.orderItem = new Common.ModelBinder(Common.OrderItem);
  }
  public id: number = 0;
  public deliveryNo: string = null;
  public deliveryItemNo: string = '';
  public delivery: Common.Delivery = null;
  public seqNo: number = 0;
  public orderItemId: number = null;
  public orderItem: Common.OrderItem = null;
  public commodityName: string = '';
  public isNCV: boolean = false;
  public description: string = '';
  public deliveryDate: Date = new Date().getCalendarDate();
  public bookDate: Date = null;
  public invoiceType: Common.InvoiceTypes = 0;
  public invoiceNo: string = null;
  public exchangeRate:number = 0;
  public uom: Common.Conversion = null;
  public set uom2(conv : Common.Conversion){
    if(conv == null || conv.code == null) this.uom = null;
    else this.uom = conv;
  }
  public get uom2(): Common.Conversion{
    if(this.uom != null)return this.uom;
    if(this.commodity != null)return this.commodity.getDefaultConversion();
  }
  // EC連携、現金清算済み金額
  public cashReceived: number = 0;
  // public get workflowHolder():string{
  //   //完了ステータスはブランク/出荷指示待ちは受注/その他は出荷から取得
  //   if (this.state == Common.StockBalanceJournalStatus.SalesDeliveryClosingWaiting || 
  //       this.state == Common.StockBalanceJournalStatus.SalesDeliveryCompleted ||
  //       this.state == Common.StockBalanceJournalStatus.PurchaseDeliveryCompleted) return '';
  //   else if (this.state == Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting && this.orderItem && this.orderItem.order) return this.orderItem.order.workflowHolder;
  //   else if (this.delivery) return this.delivery.workflowHolder;
  //   else return super.workflowHolder;
  // }

  // public set workflowHolder(value:string){
  //   super.workflowHolder = value;
  // }

  //明細タブ用のプロパティ
  public get orderNo() {
    if (this.orderItem)return this.orderItem.orderNo;
    else return '';
  }
  public get orderItemNo() {
    if (this.orderItem)return this.orderItem.orderItemNo;
    else return '';
  }
  public get salesOrderNo() {
    if (this.salesOrderItemNo && this.salesOrderItemNo.indexOf('-') > 0)return this.salesOrderItemNo.split('-')[0];
    else return '';
  }
  public get salesOrderItemNo() {
    if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase && this.orderItem)return this.orderItem.salesOrderItemNo;
    else return '';
  }  
  public get linkOrder() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) return String.format('/sales/SalesOrder?orderNo={0}', this.orderNo);
      else return String.format('/purchase/PurchaseOrder?orderNo={0}', this.orderNo);
  }
  public get linkOrderItem() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) return String.format('/sales/SalesOrderItem?orderItemNo={0}', this.orderItemNo);
      else return String.format('/purchase/PurchaseOrderItem?orderItemNo={0}', this.orderItemNo);
  }  
  public get linkSalesOrder() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase) return String.format('/sales/SalesOrder?orderNo={0}', this.salesOrderNo);
      else return '';
  }
  public get linkSalesOrderItem() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase) return String.format('/sales/SalesOrderItem?orderItemNo={0}', this.salesOrderItemNo);
      else '';
  }    
  public get linkDelivery() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) return String.format('/sales/SalesDelivery?deliveryNo={0}', this.deliveryNo);
      else return String.format('/purchase/PurchaseDelivery?deliveryNo={0}', this.deliveryNo);
  }
  public get linkDeliveryItem() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) 
      {
        if(this.state <= Common.StockBalanceJournalStatus.SalesDelivering) return String.format('/sales/SalesDeliveryItem?deliveryItemNo={0}', this.deliveryItemNo);
        else return String.format('/sales/InvoiceItem?deliveryItemNo={0}', this.deliveryItemNo);
      } 
      else return String.format('/purchase/PurchaseDeliveryItem?deliveryItemNo={0}', this.deliveryItemNo);
  }  
  public get linkInvoice (){
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales && this.invoiceType != Common.InvoiceTypes.ConsolidateInvoiceCarryOver)
          return String.format('/sales/AloneInvoice?invoiceNo={0}', this.invoiceNo);
      else if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales && this.invoiceType == Common.InvoiceTypes.ConsolidateInvoiceCarryOver)      
          return String.format('/sales/CarryOverInvoice?invoiceNo={0}', this.invoiceNo);
      else 
          return '';
  }
  public get linkInvoiceItem() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) return String.format('/sales/SalesDeliveryItem?deliveryItemNo={0}&isInvoiceItem=true', this.deliveryItemNo);
      else return '';
  }    

  // 在庫
  public specificPurchaseItemNo: number = null;
  public allocatePurchaseItemId: number = null;
  public directDeleteFlag: boolean = false;
  public deliveryFlag: Common.DeliveryFlags = 0;

  public copy():any {
    const temp = super.copy() as DeliveryItem;
    temp.id = 0;
    temp.stockPricing = null;
    temp.stockBalance = null;
    temp.specificPurchaseItemNo = null;
    return temp;
  }


  public onChangeCommodity(tenantSettings: Common.TenantSettings){
    if(this.commodity == null){
      this.commodityName = '';
      this.package = null;
      this.uom = null;
      this.description = '';
      this.unitPrice = 0;
      this.taxCode = '';
      this.reserveText1 = '';
      this.reserveText2 = '';
      this.reserveText3 = '';
      this.reserveText4 = '';
      this.reserveText5 = '';
      this.reserveText6 = '';
      this.reserveMemo1 = '';
      this.reserveMemo2 = '';
      this.reserveMemo3 = '';
      this.reserveList1 = null;
      this.reserveList2 = null;
      this.reserveList3 = null;
    }
    else{
      this.commodityName = this.commodity.name;
      this.package = '';
      this.uom = null;
      this.description = this.commodity.description;

      if(tenantSettings.usedTypeDetailReserveText1 == Common.UsedTypes.DeliveryMemo) this.reserveText1 = this.commodity.reserveText1;
      if(tenantSettings.usedTypeDetailReserveText2 == Common.UsedTypes.DeliveryMemo) this.reserveText2 = this.commodity.reserveText2;
      if(tenantSettings.usedTypeDetailReserveText3 == Common.UsedTypes.DeliveryMemo) this.reserveText3 = this.commodity.reserveText3;
      if(tenantSettings.usedTypeDetailReserveText4 == Common.UsedTypes.DeliveryMemo) this.reserveText4 = this.commodity.reserveText4;
      if(tenantSettings.usedTypeDetailReserveText5 == Common.UsedTypes.DeliveryMemo) this.reserveText5 = this.commodity.reserveText5;
      if(tenantSettings.usedTypeDetailReserveText6 == Common.UsedTypes.DeliveryMemo) this.reserveText6 = this.commodity.reserveText6;
      if(tenantSettings.usedTypeDetailReserveMemo1 == Common.UsedTypes.DeliveryMemo) this.reserveMemo1 = this.commodity.reserveMemo1;
      if(tenantSettings.usedTypeDetailReserveMemo2 == Common.UsedTypes.DeliveryMemo) this.reserveMemo2 = this.commodity.reserveMemo2;
      if(tenantSettings.usedTypeDetailReserveMemo3 == Common.UsedTypes.DeliveryMemo) this.reserveMemo3 = this.commodity.reserveMemo3;
      if(tenantSettings.usedTypeDetailReserveList1 == Common.UsedTypes.DeliveryMemo) this.reserveList1 = this.commodity.reserveList1;
      if(tenantSettings.usedTypeDetailReserveList2 == Common.UsedTypes.DeliveryMemo) this.reserveList2 = this.commodity.reserveList2;
      if(tenantSettings.usedTypeDetailReserveList3 == Common.UsedTypes.DeliveryMemo) this.reserveList3 = this.commodity.reserveList3;      
    }
  }
  public get messageOnEdit():string { 
    if(this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales)
      return 'ワークフローが進行しているため編集できません。\r\n出荷伝票のワークフローのボタンを操作し、状態を「出荷確定待ち」に戻してから編集してください。';
    else
      return 'ワークフローが進行しているため編集できません。\r\n入荷伝票のワークフローのボタンを操作し、状態を「入荷確定待ち」に戻してから編集してください。';
  }
  public get messageOnDelete():string {
    if(this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales){
      return 'ワークフローが進行しているため削除できません。\r\n出荷伝票のワークフローのボタンを操作し、状態を「出荷確定待ち」に戻してから削除してください。';
    }else{
      switch(this.state){
        case Common.StockBalanceJournalStatus.PurchaseDelivering:
          return '計上されているため削除できません。\r\n先に【関連伝票】より関連する仕入伝票を計上取消してください。';
        case Common.StockBalanceJournalStatus.PurchaseDeliveryCompleted:
          return 'ワークフローが進行しているため削除できません。\r\n入荷伝票のワークフローのボタンを操作し、状態を「入荷確定待ち」に戻してから削除してください。';
        default: return super.messageOnDelete;
      }
    }
  }
}

export class SalesDeliveryItem extends DeliveryItem{
  constructor(){
    super()
    this.salesPurchaseFlag = 1;
    // this.workflowCode="salesDeliveryItem";
    this.state = Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting;
    // this.workflowStateId = Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting;
  }
  public stockQuantity2:number = null;
  public isStockBalance:boolean = false;

  public copy():any {
    if(this.delivery.state != Common.DeliveryStatus.SalesDeliveryPostWaiting) throw new Error("出荷伝票が確定しています。");
    const temp = super.copy() as SalesDeliveryItem;
    temp.state = Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting;
    // temp.workflowStateId = Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting;
    return temp;
  }
  //返品用複製
  public copyReturn():any {
    // if(this.delivery.state != Common.DeliveryStatus.SalesDeliveryPostWaiting) throw new Error("出荷伝票が確定しています。");
    const temp = super.copy() as SalesDeliveryItem;
    temp.bookDate = null;
    temp.invoiceType = 0;
    temp.invoiceNo = '';
    temp.exchangeRate = 0;
    temp.state = Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting;
    // temp.workflowStateId = Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting;
    return temp;
  }  
}

export class DeliveryItemQuery extends Common.LoadQuery {
  constructor(salesPurchaseFlag:Common.SalesPurchaseFlags){
    super('DeliveryItemQuery', salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase ? PurchaseDeliveryItem : SalesDeliveryItem);
    this.salesPurchaseFlag = salesPurchaseFlag;
    this.state = salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase ? Common.StockBalanceJournalStatus.PurchaseDeliveryNotCompleted : Common.StockBalanceJournalStatus.SalesDeliveryItem;
    this.sort = 'deliveryItemNo';
  }
  public get binder(): Common.ModelBinder {
    var binder = super.binder;
    binder.createInstance = ()=>new DeliveryItemQuery(this.salesPurchaseFlag);    
    return binder;
  }
  public salesPurchaseFlag: Common.SalesPurchaseFlags = Common.SalesPurchaseFlags.Sales;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public pic: string = '';
  public warehouse: Common.Counterpart = null;
  public commodity: Common.Commodity = null;
  public sku: Common.SKU = null;    
  public deliveryNo: string = '';
  public deliveryItemNo: string = '';
  public orderNo: string = '';
  public orderItemNo: string = '';
  public purchaseDeliveryItemNo: string = '';
  public salesOrderItemNo:string = '';
  public receiverName:string = '';
  public commodityName: string = '';
  public skuName: string = '';
  public refNo: string = '';
  public deliveryRefNo: string = '';
  public currencyCode: string = '';  
  public customerOrderNo: string = '';
  public invoiceNo: string = '';
  // public scheduledDeliveryDateFrom: Date = null;
  // public scheduledDeliveryDateTo: Date = null;
  public deliveryDateFrom: Date = null;
  public deliveryDateTo: Date = null;
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;  
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.StockBalanceJournalStatus = Common.StockBalanceJournalStatus.SalesDeliveryNotCompleted;
  public holder: string = '';
  public auditNo: string = '';
  public partialInclude:boolean = false;
  public isInvoiceItem = false; //フィルタ動作を制御

  //予備項目
  public reserveText1: string = '';
  public reserveText2: string = '';
  public reserveText3: string = '';
  public reserveText4: string = '';
  public reserveText5: string = '';
  public reserveText6: string = '';
  public reserveMemo1: string = '';
  public reserveMemo2: string = '';
  public reserveMemo3: string = '';
  public reserveDate1From: Date = null;
  public reserveDate1To: Date = null;
  public reserveDate2From: Date = null;
  public reserveDate2To: Date = null;
  public reserveDate3From: Date = null;
  public reserveDate3To: Date = null;
  public reserveList1: number = null;
  public reserveList2: number = null;
  public reserveList3: number = null;  
}

export class DeliveryItemImportQuery extends Common.ImportQuery {
  constructor(sheetName:string, salesPurchaseFlag:number){
    super("",null);
    this.className = "DeliveryItemImportQuery";
    this.sheetName = sheetName;
    this.salesPurchaseFlag = salesPurchaseFlag;
  }
  public sheetName  :string;
  public salesPurchaseFlag : number;
  public hasLicenseCurrency: boolean = false;
}
export class DeliveryItemExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery, salesPurchaseFlag:number, isInvoiceItem:boolean = false){
    super("",loadQuery);
    this.className = "DeliveryItemExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.salesPurchaseFlag = salesPurchaseFlag;
    this.isInvoiceItem = isInvoiceItem;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
  public salesPurchaseFlag : number;
  public hasLicenseCurrency: boolean = false;
  public isInvoiceItem: boolean = false;
}

export class PurchaseDeliveryItem extends DeliveryItem{
  constructor(){
    super()
    this.salesPurchaseFlag = 0;
    // this.workflowCode="purchaseDeliveryItem";
    this.state = Common.StockBalanceJournalStatus.PurchaseDeliverySaving;
    // this.workflowStateId = Common.StockBalanceJournalStatus.PurchaseDeliverySaving;
  }
  public isPurchaseInvoicePost: boolean;
  public get virtualState() : Common.StockBalanceJournalStatus{
    if (this.state == Common.StockBalanceJournalStatus.PurchaseDeliveryCompleted && this.isPurchaseInvoicePost) return Common.StockBalanceJournalStatus.PurchasePostCompleted;
    else return this.state;
  }
  public copy():any {
    const temp = super.copy() as PurchaseDeliveryItem;
    temp.state = Common.StockBalanceJournalStatus.PurchaseDeliverySaving;
    // temp.workflowStateId = Common.StockBalanceJournalStatus.PurchaseDeliverySaving;
    return temp;
  }
}

export class ShippingInstructionsQuery extends Common.Query {
    constructor(){
        super('ShippingInstructionsQuery',new Common.ModelBinder(Common.Delivery,true));
    }
    public deliveryItems: Array<DeliveryItem> = new Array(0);
    public workflowId = 0;
    public actionId: number = 0;
    public pic: string = '';
    public refNo: string = '';
    public deliveryDate: Date = new Date().getCalendarDate();
    public receiver: Common.Counterpart = null;
    public outputReceiverPostalCode: string = '';
    public outputReceiverAddress1: string = '';
    public outputReceiverAddress2: string = '';
    public outputReceiverAddress3: string = '';
    public outputReceiverName: string = '';
    public outputReceiverPICSection: string = '';
    public outputReceiverPIC: string = '';
    public outputReceiverPICHonorificTitle: string = '';
    public outputReceiverTelNo: string = '';
    public outputReceiverFaxNo: string = '';
    public deliveryInstruction: string = '';
}

export class ReturnDeliveryQuery extends Common.Query {
    constructor(){
        super('ReturnDeliveryQuery',new Common.ModelBinder(DeliveryItem,false));
    }
    public deliveryItems: Array<DeliveryItem> = new Array(0);
    public baseItems: Array<DeliveryItem> = new Array(0);
    public pic: string = '';
    public deliveryDate: Date = new Date().getCalendarDate();
    public workflowId :number = 0;
    public invoiceWorkflowId :number = 0;        
    public actionId:number = 0;
}

export class BookSalesQuery extends Common.Query {
    constructor(){
        super('BookSalesQuery',new Common.ModelBinder(Common.Invoice,true));
    }
    public deliveryItems: Array<DeliveryItem> = new Array(0);
    public separateInvoiceFlag: boolean = false;
    public bookDate: Date = new Date().getCalendarDate();
    public dueDate: Date = new Date().getCalendarDate();
    public bulkFlag: boolean = false;
    public exchangeRate: number = 1;
    public bankAccount: Common.BankAccount = null;
    public workflowIdAlone:number = 0;
    public workflowIdCarryOver:number = 0;    
    public actionId:number = 0;
}

export class CancelBookSalesQuery extends Common.Query {
    constructor(){
        super('CancelBookSalesQuery',new Common.ModelBinder(DeliveryItem,false));
    }
    public deliveryItems: Array<DeliveryItem> = new Array(0);
}

export class DeliveryGetItemPriceQuery extends Common.Query{
  constructor(delivery:Common.Delivery, item:Common.DeliveryItem){
    super('DeliveryGetItemPriceQuery', new Common.ModelBinder(DeliveryItem, false));
    this.deliveryItem = item;
    this.deliveryItem.delivery = delivery;
    if(delivery.segment != null) this.deliveryItem.segment = delivery.segment;
  }
  public deliveryItem: Common.DeliveryItem;
}

export class GetDeliveryCounterpart extends Common.Query{
  constructor(){
    super('GetDeliveryCounterpart', new Common.ModelBinder(Common.Counterpart, false));
  }
  public delivery: Common.Delivery;
}